<script setup lang="ts">
definePage({
  meta: {
    id: 'ferme',
    title: 'Ma ferme',
    icon: 'mdi-barn',
    drawerIndex: 5,
    breadcrumb: 'disabled',
    requiresAuth: true,
    requiresSiteAccess: 'semis' // TODO Ajouter un accès pour les utilisateurs qui font parti d'une ferme
  },
})
</script>
<template>
  <RouterWrapper />
</template>
